import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { constants, translations } from 'gipsy-misc'
import { user } from 'gipsy-api'
import PreferenceChoice from './preferencechoice'
import { Header, SectionContainer } from 'pages/settings/components/common'

const propTypes = {
  user: PropTypes.object.isRequired
}

class Notifications extends PureComponent {
  state = {
    saved: false,
    selectedPreference: ''
  }

  constructor(props) {
    super(props)
    this.state = { ...this.state, selectedPreference: this.props.user.settingsPreferences.notification }
  }

  componentDidUpdate = prevProps => {
    if (prevProps.user.settingsPreferences.notification !== this.props.user.settingsPreferences.notification) {
      this.setState({ selectedPreference: this.props.user.settingsPreferences.notification })
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  onToggleSelect = async value => {
    this.setState({ selectedPreference: value })
    try {
      await user.patch(undefined, { notificationsPreference: value })
      this.setSave()
    } catch (err) {
      this.props.handleAPIError(err)
    }
  }

  setSave = () => {
    this.setState({ saved: true })
    this.timeout = setTimeout(() => {
      this.setState({ saved: false })
    }, 5000)
  }

  render = () => {
    const sections = constants.notificationsPreferences
    return (
      <SectionContainer>
        <Header title={translations.settings.section.notifications.title} isSaved={this.state.saved} />
        {sections.map(section => {
          return (
            <PreferenceChoice
              key={section}
              value={section}
              title={translations.settings.section.notifications[section].title}
              subtitle={translations.settings.section.notifications[section].subtitle}
              isSelected={this.state.selectedPreference === section}
              onToggleSelect={this.onToggleSelect}
            />
          )
        })}
      </SectionContainer>
    )
  }
}

Notifications.propTypes = propTypes

export default Notifications



// WEBPACK FOOTER //
// ./src/pages/settings/components/notifications/index.js